// @flow
const styles: Function = (theme: Object): Object => ({
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
        top: 33,
        width: '100%',
    },
    search: {
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative',
        width: '87%'
    },
    searchRoot: {
        flexWrap: 'nowrap',
        height: 40,
        padding: 0,
        marginTop: '0px !important',
    },
    searchInput: {
        border: 'none',
        fontSize: 14,
        padding: '6px 12px 6px 35px',
        height: 'initial',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '@media (max-width: 1129px)': {
            width: 400
        }
    },
    mobileSearchInput: {
        marginTop: '0px'
    },
    searchFormLabel: {
        display: 'none',
    },
    searchAdornment: {
        position: 'absolute',
        top: 10,
        left: 10,
    },
    searchAdornmentSVG: {
        width: 20,
        height: 20,
    },
});

export default styles;
